// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';


import {
    Row,
    Col,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';


import classnames from 'classnames';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { currencyFormat } from '../../helpers/formatter';
import moment from 'moment';

import DateFromToRange from '../../components/DateFromToRange';
import { fetchJSON } from '../../helpers/api';

import { noDataIndication } from '../../helpers/noDataIndication'
import Transactions from './Transactions';
import PrepaidCashDetails from './PrepaidCashDetails';
import PrepaidCreditDetails from './PrepaidCreditDetails';


class StatementOfAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            transactionData: this.props.transactionData,
            prepaidCashData: this.props.prepaidCashData,
            prepaidCreditData: this.props.prepaidCreditData,
            fromDate: this.props.fromDate,
            toDate: this.props.toDate,
            loading: this.props.loading,
            loadingTransactions: this.props.loadingTransactions,
            loadingPrepaidCash: this.props.loadingPrepaidCash,
            loadingPrepaidCredit: this.props.loadingPrepaidCredit,
            refresh: false,
            tabHeadings: this.props.tabHeadings,
            activeTab: '0',
        };

        this.changeDates = this.changeDates.bind(this);
        this.refreshDataByDateRange = this.refreshDataByDateRange.bind(this);
    }


    componentDidUpdate(prevProps) {
        // refresh data after refresh button clicked 
        // must check props have changed (this.props.refresh !== prevProps.refresh) to avoid infinite loop
        if (this.props.loading !== prevProps.loading) {
            this.setState({
                data: this.props.data,
                loading: this.props.loading,
            });
        };

        if (this.props.loadingTransactions !== prevProps.loadingTransactions) {
            this.setState({
                transactionData: this.props.transactionData,
                loadingTransactions: this.props.loadingTransactions
            });
        };

        if (this.props.loadingPrepaidCash !== prevProps.loadingPrepaidCash) {
            this.setState({
                prepaidCashData: this.props.prepaidCashData,
                loadingPrepaidCash: this.props.loadingPrepaidCash
            });
        };

        if (this.props.loadingPrepaidCredit !== prevProps.loadingPrepaidCredit) {
            this.setState({
                prepaidCreditData: this.props.prepaidCreditData,
                loadingPrepaidCredit: this.props.loadingPrepaidCredit
            });
        };

        if (this.props.tabHeadings !== prevProps.tabHeadings) {
            this.setState({
                tabHeadings: this.props.tabHeadings,
            });
        };
    }


    async loadStatementOfAccount() {
        let fromDate = moment(this.state.fromDate, moment.ISO_8601).format("DD-MMM-YYYY");
        let toDate = moment(this.state.toDate, moment.ISO_8601).format("DD-MMM-YYYY");
        //let url = `/portal/LeaseAccount/GetTransTotals?fromDate=${fromDate}&toDate=${toDate}`;
        let url = `/portal/LeaseAccount/GetStatementOfAccount?fromDate=${fromDate}&toDate=${toDate}`;
        let response = await fetchJSON(url);
        let lessees = [...new Set(response.data.totals.map(({ partyName }) => partyName))];
        
        this.setState({
            data: response.data.totals,
            loading: response.loading,
            transactionData: response.data.transactions,
            loadingTransactions: response.loading,
            prepaidCashData: response.data.prepaidCash,
            loadingPrepaidCash: response.loading,
            prepaidCreditData: response.data.prepaidCredit,
            loadingPrepaidCredit: response.loading,
            tabHeadings: [...lessees],
        });
    }


    changeDates(fromDate, toDate) {
        this.setState({
            fromDate: fromDate,
            toDate: toDate
        });
    };

    refreshDataByDateRange() {
        this.setState({
            data: [],
            transactionData: [],
            prepaidCashData: [],
            prepaidCreditData: [],
            loading: true,
            loadingTransactions: true,
            loadingPrepaidCash: true,
            loadingPrepaidCredit: true,
            refresh: true
        });

        // reload the grid
        this.loadStatementOfAccount();
    };


    /**
    * Toggle the tab
    */
    toggle = (tab: string) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    render() {

        const rowClasses = (row) => {            
            if (row.serialNo) {
                if (row.serialNo.toLowerCase().startsWith('total') || row.serialNo.toLowerCase().startsWith('less')) {
                    return 'font-weight-bold';
                }
            }
        };


        const columns = [
            {
                dataField: 'serialNo',
                text: '',
            },
            {
                dataField: 'leaseNo',
                text: 'Lease No',
                searchable: false,
                hidden: true
            },
            {
                dataField: 'rental',
                text: 'Rental',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'supplementaryRent',
                text: 'Supplementary Rent',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'commitmentFee',
                text: 'Commitment Fee',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'latePaymentInterest',
                text: 'Late Payment Interest',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'other',
                text: 'Other',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'total',
                text: 'Total',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
        ];


        return (
            <React.Fragment>
                {this.state.tabHeadings.length <= 1 && (
                    <React.Fragment>
                        <ToolkitProvider
                            bootstrap4
                            keyField="keyField"
                            data={this.state.data}
                            columns={columns}
                        >
                            {props => (
                                <React.Fragment>
                                    <Row>
                                        <Col className="d-flex justify-content-end">
                                            <React.Fragment>
                                                <DateFromToRange fromDate={this.state.fromDate} toDate={this.state.toDate} onDateRangeChange={this.changeDates} />
                                                &nbsp;
                                                <Button color="primary" className="btn-icon" onClick={this.refreshDataByDateRange} >
                                                    <i className="mdi mdi-autorenew"></i>
                                                </Button>
                                            </React.Fragment>
                                        </Col>
                                    </Row>
                                    <br />
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bordered={false}
                                        noDataIndication={noDataIndication(this.state.loading)}
                                        hover
                                        wrapperClasses="table-responsive"
                                        rowClasses={rowClasses}
                                    />
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                        <Transactions
                            data={this.state.transactionData}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            loading={this.state.loadingTransactions}
                            refresh={this.state.refresh}
                        />
                        <PrepaidCashDetails
                            data={this.state.prepaidCashData}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            loading={this.state.loadingPrepaidCash}
                            refresh={this.state.refresh}
                        />
                        <PrepaidCreditDetails
                            data={this.state.prepaidCreditData}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            loading={this.state.loadingPrepaidCredit}
                            refresh={this.state.refresh}
                        />
                    </React.Fragment>
                )}

                {/* Multiple parties */}
                {this.state.tabHeadings.length > 1 && (
                    <React.Fragment>
                        <Nav tabs className="nav-bordered">
                            {this.state.tabHeadings.map((tab, index) => {
                                return (
                                    <NavItem key={index}>
                                        <NavLink
                                            href="#"
                                            className={classnames({ active: this.state.activeTab === index.toString() })}
                                            onClick={() => {
                                                this.toggle(index.toString());
                                            }}>
                                            <span>{tab}</span>
                                        </NavLink>
                                    </NavItem>
                                );
                            })}
                        </Nav>

                        <br />

                        <ToolkitProvider
                            bootstrap4
                            keyField="keyField"
                            data={this.state.data.filter(l => l.partyName === this.state.tabHeadings[this.state.activeTab])}
                            columns={columns}
                        >
                            {props => (
                                <React.Fragment>
                                    <Row>
                                        <Col className="d-flex justify-content-end">
                                            <React.Fragment>
                                                <DateFromToRange fromDate={this.state.fromDate} toDate={this.state.toDate} onDateRangeChange={this.changeDates} />
                                                &nbsp;
                                                <Button color="primary" className="btn-icon" onClick={this.refreshDataByDateRange} >
                                                    <i className="mdi mdi-autorenew"></i>
                                                </Button>
                                            </React.Fragment>
                                        </Col>
                                    </Row>
                                    <br />
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bordered={false}
                                        noDataIndication={noDataIndication(this.state.loading)}
                                        hover
                                        wrapperClasses="table-responsive"
                                        rowClasses={rowClasses}
                                    />
                                </React.Fragment>
                            )}
                        </ToolkitProvider>

                        <Transactions
                            data={this.state.transactionData.filter(l => l.partyName === this.state.tabHeadings[this.state.activeTab])}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            loading={this.state.loadingTransactions}
                            refresh={this.state.refresh}
                        />
                        <PrepaidCashDetails
                            data={this.state.prepaidCashData.filter(l => l.partyName === this.state.tabHeadings[this.state.activeTab])}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            loading={this.state.loadingPrepaidCash}
                            refresh={this.state.refresh}
                        />
                        <PrepaidCreditDetails
                            data={this.state.prepaidCreditData.filter(l => l.partyName === this.state.tabHeadings[this.state.activeTab])}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            loading={this.state.loadingPrepaidCredit}
                            refresh={this.state.refresh}
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}


export default withRouter(
    connect()(StatementOfAccount)
);